import {BusinessCaseType} from "../../location/_models/_enums/business-case-type";
import {BusinessCaseCalculationType} from "./_enums/business-case-calculation-type";

export class BusinessCaseNew {
  name: string = "";
  type: BusinessCaseType = BusinessCaseType.Umsatz;
  calculationType: BusinessCaseCalculationType = BusinessCaseCalculationType.Absolute;
  value: number = 0;

  public clear() {
    this.name = "";
    this.type = BusinessCaseType.Umsatz;
    this.calculationType = BusinessCaseCalculationType.Absolute;
    this.value = 0;
  }
}
